import Setting from './model.js'
import { deepGet } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    current: new Setting(),
  },
  getters: {
    getCurrent: state => state.current
  },
  actions: {
    get (state, payload) {
      return this.dispatch('get', {
        path: 'v1/configs/system/null',
      }).then((res) => {
        const data = deepGet(res, 'body.data.value')
        const commitData = data.length > 0 || typeof data === 'object' ? data : new Setting()
        state.commit('updateCurrent', commitData)
      })
    },
    update (state, payload) {
      return this.dispatch('post', {
        path: 'v1/configs/',
        data: {
          type: 'system',
          modelId: null,
          value: payload
        }
      })
    }
  },
  mutations: {
    updateCurrent (state, data) {
      state.current.set(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/store.js